import React, { useEffect, useRef } from 'react';

function AdBanner({ format = 'auto', slot = '' }) {
  const adRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const timer = setTimeout(() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        // AdSense not ready
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="ad-banner">
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-8004994096344735"
        data-ad-format={format}
        data-full-width-responsive="true"
        {...(slot && { 'data-ad-slot': slot })}
      />
    </div>
  );
}

export default AdBanner;
